import { DsChipColorVariant } from '@levelaccess/design-system';

import { $scan } from '../../../shared/constants/scan';
import { ScanOrigin } from '../../../shared/constants/scanning';
import { IScan } from '../../../shared/interfaces/scan.interface';

export class MobileScanOriginUtility {
  public static getTranslationKey(scan: IScan): string | null {
    const origin: ScanOrigin = scan[$scan.scanOrigin];
    const isMobileFlawMatchingEnabled: boolean = scan[$scan.isMobileFlawMatchingEnabled] === true;
    const translationKeyMap: Partial<Record<ScanOrigin, string>> = {
      [ScanOrigin.mobile_sdk]: 'sdk',
      [ScanOrigin.mobile_emulator]: 'live_app_testing',
      [ScanOrigin.mobile_xml]: 'xml',
      [ScanOrigin.mobile_engine_desktop]: isMobileFlawMatchingEnabled ? 'odt_supervised' : 'odt_standalone',
      [ScanOrigin.mobile_engine_crawling]: 'odt_crawling',
      [ScanOrigin.mobile_engine_sdk]: 'mobile_engine_sdk',
    };
    return translationKeyMap[origin] ?? null;
  }

  public static getChipVariant(scan: IScan): DsChipColorVariant {
    const origin: ScanOrigin = scan[$scan.scanOrigin];
    const isMobileFlawMatchingEnabled: boolean = scan[$scan.isMobileFlawMatchingEnabled] === true;
    switch (origin) {
      case ScanOrigin.mobile_emulator:
        return DsChipColorVariant.LightBlue;
      case ScanOrigin.mobile_xml:
        return DsChipColorVariant.Info;
      case ScanOrigin.mobile_engine_desktop:
        return isMobileFlawMatchingEnabled ? DsChipColorVariant.Primary : DsChipColorVariant.Orange;
      case ScanOrigin.mobile_engine_crawling:
        return DsChipColorVariant.Ai;
      case ScanOrigin.mobile_sdk:
      case ScanOrigin.mobile_engine_sdk:
      default:
        return DsChipColorVariant.LightGray;
    }
  }
}
